export const PREVIEW_LOAD_TIMEOUT_MS = 8_000;

/** Rejects when `promise` does not settle. The original work may still finish later. */
export function withTimeout<T>(
  promise: Promise<T>,
  ms: number = PREVIEW_LOAD_TIMEOUT_MS,
): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('preview_timeout')), ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error: unknown) => {
        clearTimeout(timer);
        reject(error instanceof Error ? error : new Error('preview_failed'));
      },
    );
  });
}
